require("jquery-zoom");

exports.init = function ($) {
  $('#product-zoom').each(function(){
    $(this).zoom({
      'url': $(this).data('image-large'),
      'touch': 'true'
    });
  })
};
